import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { CommonService } from '../../../Model/Common/common.service';
import { LetterDocumentService } from '../../../Model/LetterDocument/letter-document.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ComboService } from '../../../Model/Combo/combo.service';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
  selector: 'app-letter-document-type-form',
  standalone: true,
  imports: [FormsModule, CommonModule, LoaderComponent, NgSelectModule],
  templateUrl: './letter-document-type-form.component.html',
  styleUrl: './letter-document-type-form.component.scss'
})
export class LetterDocumentTypeFormComponent {
  isDisabled: boolean = false;
  activeModal = inject(NgbActiveModal);
  @Input() ID!: number;

  EmployeeStatus = [];

  LetterDocumentDetail = {
    SelectType: 'I',
    ESS_LetterDocumentTypeMasterID: 0,
    LetterDocumentTypeCode: null as any,
    LetterDocumentTypeName: null,
    IncludeInSalaryRateContract: false,
    EMPAcknowledgement: false,
    LetterIssuanceLimit: 1,
    IncludeESignIn: false,
    AddESignInOn: null,
    Xcoordinate: null as any,
    Ycoordinate: null as any,
    Active: true,
    ESS_LetterModuleTypeId: null,
  }

  constructor(
    private toast: ToastService,
    private modalService: NgbModal,
    protected common: CommonService,
    private tooltip: TooltipService,
    private letterDocument: LetterDocumentService,
    private combo: ComboService,
  ) {
    this.common.getPageRights();
  }

  ngOnInit(): void {
    this.LetterDocumentDetail.ESS_LetterDocumentTypeMasterID = this.ID;
    this.ComboLoad('ESS_LetterModuleType');
    if (this.ID > 0) {
      this.ESSLetterDocumentTypeMasterSelect();
    }
  }

  Validate(form: any) {
    if (form.valid) {
      if (this.LetterDocumentDetail.LetterIssuanceLimit >= 0) {
        if (this.LetterDocumentDetail.ESS_LetterModuleTypeId == 3) {
          this.LetterDocumentDetail.EMPAcknowledgement = false;
          this.LetterDocumentDetail.IncludeESignIn = false;
        }

        if (!this.common.CompanyParameterValue.IsESignInAllowed || !this.LetterDocumentDetail.IncludeESignIn) {
          this.LetterDocumentDetail.IncludeESignIn = false;
          this.LetterDocumentDetail.AddESignInOn = null;
          this.LetterDocumentDetail.Xcoordinate = null;
          this.LetterDocumentDetail.Ycoordinate = null;
        }

        if (this.LetterDocumentDetail.IncludeESignIn && (this.LetterDocumentDetail.AddESignInOn == null || this.LetterDocumentDetail.Xcoordinate == null || this.LetterDocumentDetail.Ycoordinate == null || this.LetterDocumentDetail.AddESignInOn == '')) {
          //if (this.LetterDocumentDetail.IncludeESignIn && (this.LetterDocumentDetail.AddESignInOn == null || this.LetterDocumentDetail.Xcoordinate == null || this.LetterDocumentDetail.Ycoordinate == null || this.LetterDocumentDetail.AddESignInOn == '' || this.LetterDocumentDetail.Xcoordinate == '' || this.LetterDocumentDetail.Ycoordinate == '')) {
          this.toast.show({ message: 'Enter all eSign configartion details', type: toastTypeEnum.warning });
        } else {
          if (!this.LetterDocumentDetail.IncludeESignIn || (this.LetterDocumentDetail.IncludeESignIn && this.LetterDocumentDetail.Xcoordinate >= 0 && this.LetterDocumentDetail.Xcoordinate <= 430 && this.LetterDocumentDetail.Ycoordinate >= 0 && this.LetterDocumentDetail.Ycoordinate <= 800)) {
            this.ESSLetterDocumentTypeMasterInsertUpdate();
          } else {
            this.toast.show({ message: 'X Cordinate must be between 0 to 430 and Y Cordinate must be between 0 to 800', type: toastTypeEnum.warning });
          }
        }
      } else {
        this.toast.show({ message: 'Letter Issuance Limit Must be Greater Than 0', type: toastTypeEnum.warning });
      }

    }
    else {
      form.submitted = true;
    }
  }

  ESSLetterDocumentTypeMasterSelect() {
    this.isDisabled = true;
    this.letterDocument.ESSLetterDocumentTypeMasterSelect({ ESS_LetterDocumentTypeMasterID: this.LetterDocumentDetail.ESS_LetterDocumentTypeMasterID, SelectType: 1 }).subscribe({
      next: (response) => {
        this.LetterDocumentDetail = response.Table[0];
        this.LetterDocumentDetail.SelectType = 'U';
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async ESSLetterDocumentTypeMasterInsertUpdate() {
    //await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to save?';
    modalRef.result.then((result) => {
      if ((this.LetterDocumentDetail.ESS_LetterDocumentTypeMasterID == 0 && this.common.PageRight.IsAdd) || (this.LetterDocumentDetail.ESS_LetterDocumentTypeMasterID > 0 && this.common.PageRight.IsEdit)) {
        if (result) {
          this.isDisabled = true;
          this.LetterDocumentDetail.LetterDocumentTypeCode = this.common.ToUpperCase(this.LetterDocumentDetail.LetterDocumentTypeCode);
          this.letterDocument.ESSLetterDocumentTypeMasterInsertUpdate(this.LetterDocumentDetail).subscribe({
            next: (response) => {
              if (response.Error_Code == '531' || response.Error_Code == '533') {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.activeModal.close(true);
                  }
                });
              }
              else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              console.log(response.Error_Message);
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    });
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    if (Combotype == 'ESS_LetterModuleType') {
      this.EmployeeStatus = [];
    }

    this.combo.ComboLoad({
      'Combotype': Combotype
    }).subscribe({
      next: (response) => {
        if (response.ComboLoad) {
          if (Combotype == 'ESS_LetterModuleType') {
            this.EmployeeStatus = response.ComboLoad;
          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  close() {
    this.activeModal.close();
  }
}
